import { useState } from "react";
import { getSupabase, supabaseConfigured } from "../lib/supabase";
import { useLang, useTheme } from "../lib/prefs";
import { PrefsToggles } from "./PrefsToggles";
import { GoogleIcon } from "./GoogleIcon";

const T = {
  es: {
    lead: "Mide qué tan seguido la IA te recomienda a tus clientes ideales — y recibe los cambios semanales para mejorar.",
    cta: "Continuar con Google",
    connecting: "Conectando…",
    foot: "Al continuar aceptas nuestros Términos y Aviso de Privacidad.",
    notConfigured:
      "Autenticación no configurada. Falta VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY.",
    err: "No se pudo iniciar sesión. Intenta de nuevo.",
  },
  en: {
    lead: "Measure how often AI recommends you to your ideal customers — and get the weekly changes to improve.",
    cta: "Continue with Google",
    connecting: "Connecting…",
    foot: "By continuing you accept our Terms and Privacy Notice.",
    notConfigured:
      "Auth not configured. Missing VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY.",
    err: "Could not sign in. Please try again.",
  },
};

export default function Login() {
  const [lang, toggleLang] = useLang();
  const [, toggleTheme] = useTheme();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const t = T[lang];

  async function signIn() {
    setError(null);
    if (!supabaseConfigured) {
      setError(t.notConfigured);
      return;
    }
    setBusy(true);
    const supabase = getSupabase();
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: `${window.location.origin}/auth/callback`,
      },
    });
    if (error) {
      setBusy(false);
      setError(t.err);
    }
    // On success the browser navigates to Google; no further UI needed.
  }

  return (
    <div className="auth">
      <div className="auth-topbar">
        <PrefsToggles
          lang={lang}
          toggleLang={toggleLang}
          toggleTheme={toggleTheme}
        />
      </div>
      <div className="auth-card">
        <div className="auth-logo">citada</div>
        <h1>{lang === "es" ? "Entrar" : "Sign in"}</h1>
        <p className="lead">{t.lead}</p>
        {error && <p className="auth-err">{error}</p>}
        <button className="g-btn" onClick={signIn} disabled={busy}>
          <GoogleIcon />
          {busy ? t.connecting : t.cta}
        </button>
        <p className="auth-foot">{t.foot}</p>
      </div>
    </div>
  );
}
